// extracted by mini-css-extract-plugin
var _1 = "_tabPageContainer-module__container";
export { _1 as "container" }
